import {useApi} from "../Api";
import {EnumInterface} from "../types/generic";

export const useTypesRepository = () => {
    const {GET} = useApi();

    const PATH = "pricing/types";

    function getAlertsType(): Promise<EnumInterface> {
        return GET(`${PATH}/alert`);
    }

    function getSchedulingType(): Promise<EnumInterface> {
        return GET(`${PATH}/scheduling`);
    }

    function getUnitType(): Promise<EnumInterface> {
        return GET(`${PATH}/unit`);
    }

    function getReportsType(): Promise<EnumInterface> {
        return GET(`${PATH}/reports`);
    }

    return {
        getAlertsType,
        getSchedulingType,
        getUnitType,
        getReportsType
    };
};
